<td>{{ audit.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
<td>Created {{ keyedProviderDataReviewTypeOptions[audit.auditableType].display }}</td>
<td>
  <div class="overflow-auto" style="max-height: 600px;" [innerHTML]="newValueHtml"></div>
</td>
<td>--</td>
<td>{{ audit.user?.email | blankValueDash }}</td>